export interface AdmissionVital {
  id: string;
  bpSystolic: number | null;
  bpDiastolic: number | null;
  pulse: number | null;
  temperatureC: number | null;
  spo2: number | null;
  respiratoryRate?: number | null;
  recordedAt: string;
}

export interface Admission {
  id: string;
  number: string;
  status: string;
  admittedAt: string;
  dischargedAt: string | null;
  provisionalDiagnosis: string | null;
  admissionNote: string | null;
  lengthOfStayDays: number;
  branchId?: string;
  payerId?: string | null;
  advanceHeldMinor?: number | string | null;
  dischargeSummarySignedAt?: string | null;
  departmentId?: string | null;
  intendedStayCode?: string | null;
  admittingSpecialtyId?: string | null;
  dischargeDispositionCode?: string | null;
  dischargeSpecialtyId?: string | null;
  causeOfDeathCode?: string | null;
  patient: {
    id: string;
    mrn: string;
    fullName: string;
    sex: string;
    dob: string | null;
    approximateAgeYears?: number | null;
    phone?: string | null;
    allergyStatus?: string | null;
    birthWeightGrams?: number | null;
    gestationalAgeWeeks?: number | null;
    gestationalAgeDays?: number | null;
    photoUrl?: string | null;
    allergies: { id: string; substance: string; reaction: string | null; severity?: string | null }[];
  };
  doctor: { id: string; name: string; designation: string | null; specialtyId?: string | null };
  bed: { id: string; code: string; bedClass: string; room: { code: string; ward: { id: string; name: string } } } | null;
  payer: { id: string; name: string } | null;
  account: { billedMinor: number; paidMinor: number; depositedMinor: number; balanceMinor: number };
  openWork?: { labItems: number; radiology: number; dueDoses: number };
  bedChargeConfigured?: boolean;
  vitals: AdmissionVital[];
  progressNotes: { id: string; subjective: string | null; objective: string | null; assessment: string | null; plan: string | null; createdAt: string }[];
  nursingNotes: { id: string; kind: string; shift: string | null; situation: string | null; recommendation: string | null; body: string | null; createdAt: string }[];
}

export interface Dose {
  id: string;
  scheduledAt: string;
  status: string;
  administeredAt: string | null;
  overdue: boolean;
  order: { id: string; label: string; dose: string | null; route: string | null; frequency: string | null; isHighAlert: boolean; isControlled: boolean; isStat?: boolean; status?: string };
}

export interface RunningBill {
  groups: { context: string; items: { description: string; qty: number; netMinor: number; packageRole?: string | null }[]; subtotalMinor: number }[];
  deposits: { at: string; type: string; amountMinor: number }[];
  totals: { billedMinor: number; paidMinor: number; depositedMinor: number; balanceMinor: number };
}

export interface DuesNote {
  id: string;
  note: string;
  promisedDate: string | null;
  promisedAmountMinor: number | null;
  createdAt: string;
  author: string | null;
}

export function admissionIsOpen(admission: Pick<Admission, 'status'>): boolean {
  return admission.status === 'admitted';
}

export function admissionPath(admissionId: string, section?: string): string {
  return section ? `/ipd/admissions/${admissionId}?section=${encodeURIComponent(section)}` : `/ipd/admissions/${admissionId}`;
}

export function ipdEmrPath(admissionId: string, section?: string): string {
  return section ? `/ipd/admissions/${admissionId}/emr?section=${encodeURIComponent(section)}` : `/ipd/admissions/${admissionId}/emr`;
}
